<app-header></app-header>

<!--====== PAGE TITLE PART START ======-->
<div class="banner-active">
    <div class="single-banner bg_cover" *ngFor="let slide of slideData;let index=i" 
         [ngStyle]="{'background-image': 'url('+slide.img+')', 'background-repeat': 'no-repeat'}">
        <div class="banner-overlay">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="banner-content text-center">
                            <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title" [innerHTML]="slide.title"></h1>
                            <span data-animation="fadeInLeft" data-delay="0.5s" class="c-sub-title">{{slide?.subTitle}}</span>
                            <div data-animation="fadeInLeft" data-delay="1.3s">
                                <span class="assurance">{{slide.type}}</span>
                                <div class="barre-bottom"></div>
                                <img class="assu-img" [src]="slide.imgIcon" alt="">
                            </div>
                            <span data-animation="fadeInUp" data-delay="1.6s" class="main-btn-title" *ngIf="title!=''">{{title}}</span>
                            <a class="main-btn" data-animation="fadeInUp" data-delay="1.6s" (click)="getDevisAutre()">Obtenir un devis</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="case-studies-area">
  <div class="container">
    
    <!-- Barre de progression -->
    <div class="row" *ngIf="currentStep > 0 && currentStep < 4">
      <div class="devis">
        <div class="title">Ma souscription Individuelle Accident</div>
        <img src="assets/images/stopwatch.svg" alt="">
      </div>
      <div class="temps">
        <span class="barre-temps"></span>
        <span class="message-temps">En quelques minutes</span>
      </div>
    </div>

    <!-- <div class="progress" *ngIf="currentStep > 0 && currentStep < 4">
      <div class="progress-bar progress-bar-striped progress-bar-animated" 
           [style.width.%]="getProgressPercentage()"></div>
      <span class="text-changement">{{getProgressText()}}</span>
    </div> -->

    <div class="latest-services-area">
      <div class="container">
        <div class="formulaire" *ngIf="currentStep >= 0">
          <form [formGroup]="souscriptionForm" class="form-wizard-container">
            
            <!-- Page d'accueil -->
            <div class="welcome-step" *ngIf="currentStep === 0">
              <div class="welcome-content">
                <h1>Bonjour ! Je suis Marilyne</h1>
                <h2>Je suis là pour vous aider</h2>
                <p class="welcome-description">
                  Obtenez votre devis d'assurance individuelle accidents en quelques minutes seulement.
                  Je vais vous guider étape par étape pour trouver la meilleure protection.
                </p>
                <button class="cta-button" (click)="nextStep()">
                  C'est parti !!
                </button>
              </div>
            </div>

            <!-- Étape 1: Accident -->
            <div class="step-container" *ngIf="currentStep === 1">
              <div class="step-header">
                <h2>Informations générales</h2>
                <!-- <p class="step-subtitle">Informations sur votre assurance accident</p> -->
                <div class="step-progress">Étape 1 sur 2</div>
              </div>

               <div class="form-grid formulaire">
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box">
                    <input type="text" formControlName="nomEntreprise" placeholder="Dénomination" noAutocomplete>
                    <i class="barre"></i>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box">
                    <input type="text" formControlName="personneContact" placeholder="Personne contact" noAutocomplete>
                    <i class="barre"></i>
                  </div>
                </div>
              </div>

              <div class="form-grid formulaire">
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box mt-30">
                    <input type="email" formControlName="email" placeholder="Courriel *" noAutocomplete>
                    <i class="barre"></i>
                  </div>
                   <div *ngIf="souscriptionForm.get('email').errors">
                      <div
                        *ngIf="souscriptionForm.get('email').errors.required && (souscriptionForm.get('email').dirty || souscriptionForm.get('email').touched)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                      <div *ngIf="souscriptionForm.get('email').errors.pattern">
                        <div class="text-red">
                          Email est invalide
                        </div>
                      </div>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box sinistre mt-30">
                    <input type="tel" 
                           formControlName="telephone"
                           ng2TelInput 
                           [ng2TelInputOptions]="{initialCountry: currentFiliale?.code}"
                           placeholder="Numéro de téléphone *"
                           (focus)="isFocus=true" 
                           (blur)="isFocus=false; hasError($event, 'telephone', 'souscriptionForm');autoSave()"
                           (ng2TelOutput)="getNumber($event, 'telephone', 'souscriptionForm')"
                           (intlTelInputObject)="telInputObject($event)" 
                           (countryChange)="onCountryChange($event)" noAutocomplete>
                  </div>
                  <div *ngIf="souscriptionForm.get('telephone').errors">
                      <div
                        *ngIf="souscriptionForm.get('telephone').errors.required && (souscriptionForm.get('telephone').dirty || souscriptionForm.get('telephone').touched)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                  </div>
                </div>
              </div>


              <div class="form-grid formulaire">
              <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                    <input type="text" formControlName="adresse" placeholder="Adresse" noAutocomplete>
                    <i class="barre"></i>
                  </div> 
               </div>
               <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                  <ng-select formControlName="fonction" 
                            clearAllText="Effacer tout" 
                            notFoundText="Aucun élément trouvé"
                            [items]="listFonctions" 
                            bindLabel="name" 
                            bindValue="name"
                            placeholder="Fonction">
                  </ng-select>
                </div>
                </div>
              </div>

           

              <div class="step-navigation">
                <button class="btn-back" (click)="currentStep = 0">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Continuer</button>
              </div>
            </div>

            <!-- Étape 2: Informations personnelles -->
            <div class="step-container" *ngIf="currentStep === 2">
              <div class="step-header">
                <h2>Informations du véhicule</h2>
                <!-- <p class="step-subtitle">Vos informations personnelles</p> -->
                <div class="step-progress">Étape 2 sur 2</div>
              </div>



                <!-- Téléchargement du questionnaire -->
      <div class="download-section" *ngIf="downloadFile">
        <div class="download-card">
          <div class="download-icon">
            <img [src]="downloadIcon" alt="Télécharger">
          </div>
          <div class="download-content">
            <h3>Questionnaire flotte obligatoire</h3>
            <p>Téléchargez et remplissez ce questionnaire avant de continuer</p>
            <button type="button" class="download-button" (click)="downloadModel()">
              <i class="fa fa-download"></i>
              Télécharger le modèle
            </button>
          </div>
        </div>
      </div>

  <!-- Upload du questionnaire -->
  <div class="upload-section">
    <div class="upload-area" (click)="fileInput.click()" 
         [class.has-file]="pieceJointe.get('file')?.value">
      <input #fileInput type="file" hidden 
             (change)="selectOnFile($event, 'PIECEJOINTE', 'PIECEJOINTE')"
             accept=".xls,.xlsx">
      
      <div class="upload-content" *ngIf="!pieceJointe.get('file')?.value">
        <i class="fa fa-cloud-upload upload-icon"></i>
        <h3>Charger le questionnaire</h3>
        <p>Cliquez ici ou glissez-déposez votre fichier</p>
        <small class="text-muted">Formats acceptés:  XLS, XLSX</small>
      </div>
      
      <div class="file-success" *ngIf="pieceJointe.get('file')?.value">
        <i class="fa fa-check-circle success-icon"></i>
        <div class="file-info">
          <p><strong>Questionnaire chargé avec succès</strong></p>
          <small class="file-name" *ngIf="nomFile">{{ nomFile }}</small>
        </div>
        <!-- Icône selon le type de fichier -->
        <div class="file-icon" *ngIf="noImage !== 'assets/images/upload.png'">
          <img [src]="noImage" alt="File type icon" class="file-type-icon">
        </div>
      </div>
    </div>
    
    <div class="loader-container" *ngIf="loader">
      <i class="fa fa-spinner fa-pulse"></i>
      <p>Chargement du fichier...</p>
    </div>
    
    <!-- Message d'erreur pour validation -->
    <div class="error-message" *ngIf="pieceJointe.get('file')?.invalid && pieceJointe.get('file')?.touched">
      <small class="text-danger">
        <i class="fa fa-exclamation-triangle"></i>
        Le questionnaire flotte est obligatoire pour continuer
      </small>
    </div>
  </div>

 


              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Voir le récapitulatif</button>
              </div>
            </div>

            <!-- Récapitulatif -->
            <div class="step-container_2" *ngIf="currentStep === 3">
              <div class="step-header">
                <h2>Récapitulatif de votre souscription flotte</h2>
                <p class="step-subtitle">Vérifiez vos informations avant de finaliser</p>
              </div>

              <div class="recap-form-container">
                <div class="mesImage">
                  <div class="imgLogo">
                    <img src="assets/images/logo.png" alt="Logo Inclusive Guarantee">
                  </div>
                </div>
                
                <div class="info-devis">
                  <div class="proposition">
                    <div class="pro-title">Demande d'assurance automobile flotte</div>
                    <div class="sub-title">{{numeroSous}}</div>
                  </div>
                  
                  <div class="row">
                    <!-- Informations sur l'accident -->
                    <!-- <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                      <div class="title-div">
                        <span>Informations sur l'accident</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('email')?.value">
                            <div class="col-5 name">Email</div>
                            <div class="col-7 value">{{souscriptionForm?.get('email')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('telephone')?.value">
                            <div class="col-5 name">Téléphone</div>
                            <div class="col-7 value">{{souscriptionForm?.get('telephone')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('adresse')?.value">
                            <div class="col-5 name">Ville</div>
                            <div class="col-7 value">{{souscriptionForm?.get('adresse')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('profession')?.value">
                            <div class="col-5 name">Profession</div>
                            <div class="col-7 value">{{souscriptionForm?.get('profession')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('dateEffet')?.value">
                            <div class="col-5 name">Date d'effet</div>
                            <div class="col-7 value">{{souscriptionForm?.get('dateEffet')?.value | date:'dd/MM/yyyy'}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('duree')?.value">
                            <div class="col-5 name">Durée</div>
                            <div class="col-7 value">{{souscriptionForm?.get('duree')?.value}} mois</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('gaucherDroitier')?.value">
                            <div class="col-5 name">Gaucher/Droitier</div>
                            <div class="col-7 value">{{souscriptionForm?.get('gaucherDroitier')?.value}}</div>
                          </div>
                        </div>
                      </div>
                    </div> -->
                    
                    <!-- Informations personnelles -->
                    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-12">
                      <div class="title-div">
                        <span>Informations personnelles</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Numéro</div>
                            <div class="col-7 value">{{numeroSous}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('nomEntreprise')?.value">
                            <div class="col-5 name">Dénomination</div>
                            <div class="col-7 value">{{souscriptionForm?.get('nomEntreprise')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('personneContact')?.value">
                            <div class="col-5 name">Personne contact</div>
                            <div class="col-7 value">{{souscriptionForm?.get('personneContact')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('email')?.value">
                            <div class="col-5 name">Courriel</div>
                            <div class="col-7 value">{{souscriptionForm?.get('email')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('telephone')?.value">
                            <div class="col-5 name">Numéro de téléphone</div>
                            <div class="col-7 value">{{souscriptionForm?.get('telephone')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('adresse')?.value">
                            <div class="col-5 name">Adresse</div>
                            <div class="col-7 value">{{souscriptionForm?.get('adresse')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('fonction')?.value">
                            <div class="col-5 name">Fonction</div>
                            <div class="col-7 value">{{souscriptionForm?.get('fonction')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Date de demande</div>
                            <div class="col-7 value">{{newDate | date:'dd/MM/yyyy'}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                      <div class="row">
        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 c-col-12">
          <div class="title-div">
            <span>Documents joints</span>
          </div>
          <div class="contenu-div">
            <div class="row">
              <div class="col-12 d-flex">
                <div class="col-5 name">Questionnaire flotte</div>
                <div class="col-7 value">
                  <span *ngIf="pieceJointe.get('file')?.value" class="text-success">
                    <i class="fa fa-check-circle"></i> Document fourni
                  </span>
                  <span *ngIf="!pieceJointe.get('file')?.value" class="text-warning">
                    <i class="fa fa-exclamation-triangle"></i> En attente
                  </span>
                </div>
              </div>
              <div class="col-12 d-flex" *ngIf="nomFile">
                <div class="col-5 name">Nom du fichier</div>
                <div class="col-7 value">{{nomFile}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
                  
                  <div class="description-ass">
                    Cette demande d'assurance automobile flotte sera traitée par nos équipes dans les plus brefs délais. 
                    Vous recevrez une confirmation par email avec les détails de votre couverture.
                  </div>
                  
                  <div class="disposition row col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div class="title-dispo-footerL col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      Demande d'assurance automobile flotte
                    </div>
                    <div class="title-dispo-footerR col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      Date émission : {{newDate | date:'dd/MM/yyyy'}} - E-MAIL : contact&#64;inclusiveguarantee.fr
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">
                  <!-- <i class="fa fa-arrow-left"></i> -->
                  Retour
                </button>
                <button type="button" class="btn-continue final-btn" [disabled]="sendingRequest" (click)="saveData()">
                  <i class="fa fa-spinner fa-pulse" *ngIf="sendingRequest"></i>
                  <span *ngIf="!sendingRequest">Finaliser la souscription</span>
                  <span *ngIf="sendingRequest">Traitement en cours...</span>
                </button>
              </div>
            </div>

            <!-- Étape de succès -->
            <div class="step-container" *ngIf="currentStep === 4">
              <div class="success-auto">
                <div class="icon-succes">
                   <img width="10%" src="/assets/images/verifier.png" alt="" srcset="">
                </div>
                <div class="message-success">
                  Votre demande a été soumise avec succès. Vous recevrez un devis sous 48h. Merci pour la confiance.
                  <!-- <span>Numéro de référence : {{numeroSous}}</span> -->
                  <span>L'équipe d'Inclusive Guarantee</span>
                </div>
                <button class="btn-success" (click)="resetForm()">
                  <span>Nouvelle demande</span>
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>